import { useQuery } from '@apollo/client';
import { graphql } from '@packages/charka-common-ui/graphql/types';

const QUERY = graphql(`
  query PageRule($id: ID!) {
    pageRule(id: $id) {
      id
      name
      printerDeviceId
      allowedSections {
        menuSectionId
        menuSection {
          id
          code
          name
        }
      }
    }
  }
`);

export function usePageRule(id: string) {
  return useQuery(QUERY, {
    variables: {
      id,
    },
  });
}
